import { directive as vDragged } from 'v-dragged'

export default {
  directives: {
    dragged: vDragged
  }
}



// WEBPACK FOOTER //
// ./src/mixins/draggable.js